import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Card, CardHeader } from '@material-ui/core';
import { useUserTable } from '../../../../libs/hooks';

const options = {
  filter: true,
  filterType: 'dropdown',
  responsive: 'vertical',
  tableBodyHeight: '400px',
  searchText: '',
  searchOpen: true,
  searchPlaceholder: '닉네임, 이름 검색',
  download: false,
  print: false,
  selectableRowsOnClick: false,
  selectableRowsHideCheckboxes: true
};

export default function MembershipTable() {
  const { headers, data } = useUserTable();

  return (
    <>
      <Card>
        <CardHeader title="멤버쉽 관리" />
      </Card>
      <MUIDataTable data={data} columns={headers} options={options} />
    </>
  );
}
